import type { Styles } from '@adornis/ass/style.js';
import { XCalendar } from '@adornis/calendar/calendar.js';
import { customElement } from 'lit/decorators.js';

/**
 * @element sg-calendar-component
 */
@customElement('sg-calendar-component')
export class SGCalendarComponent extends XCalendar {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      { '.fc-event': { cursor: 'pointer' } },
      { '.fc-timegrid-slot': { cursor: 'pointer' } },
      { '.fc-daygrid td[role="gridcell"]': { cursor: 'pointer' } },
      { '.fc-daygrid td[role="gridcell"]:hover': { backgroundColor: this.colors.neutral.shade(50) } },
    ];
  }
}
